module.exports = __webpack_public_path__ + "img/en.9d9797bc.png";